export const prifact_tables: Array<string> = [
    "CREATE TABLE IF NOT EXISTS AppContext (key TEXT PRIMARY KEY,value TEXT );",
]